var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bing-zhuang-tu-container"},[_c('dv-border-box-11',{attrs:{"title":"行业统计","titleWidth":150}},[_c('div',{staticClass:"chart-container"},[_c('div',{ref:"bing_zhuang_tu_echarts",staticClass:"chart"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }